import React from "react";
import { Reveal } from "./Reveal";
import { BackgroundGrid } from "./RouteLine";
import { LightStreaks } from "./Animations";

// Shared cinematic sub-page hero with a trucking image + overlay.
export const ServiceHero = ({ eyebrow, title, highlight, subtitle, image, price }) => (
  <section className="relative min-h-[72vh] flex items-end overflow-hidden pt-28 pb-14">
    <div className="absolute inset-0">
      <img src={image} alt="" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#060A17] via-[#060A17]/85 to-[#060A17]/55" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#060A17]/90 to-transparent" />
    </div>
    <BackgroundGrid className="opacity-30" />
    <LightStreaks />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
      <Reveal>
        {eyebrow && <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37] mb-5">{eyebrow}</p>}
      </Reveal>
      <Reveal delay={0.1}>
        <h1 className="font-head text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-[1.05] max-w-4xl">
          {title} {highlight && <span className="nm-gold-text">{highlight}</span>}
        </h1>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.2}>
          <p className="mt-6 text-gray-300 text-base sm:text-lg max-w-2xl leading-relaxed">{subtitle}</p>
        </Reveal>
      )}
      {price && (
        <Reveal delay={0.3}>
          <div className="mt-7 inline-flex items-center gap-3 nm-card rounded-full px-6 py-3">
            <span className="w-2.5 h-2.5 rounded-full bg-[#10B981] pulse-glow" />
            <span className="font-head text-lg font-bold nm-gold-text">{price}</span>
          </div>
        </Reveal>
      )}
    </div>
  </section>
);

export const SectionHeading = ({ eyebrow, children, center, className = "" }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl ${className}`}>
    {eyebrow && <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37] mb-4">{eyebrow}</p>}
    <h2 className="font-head text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white leading-tight">{children}</h2>
  </div>
);

export const CheckList = ({ items, columns = 2 }) => (
  <ul className={`grid grid-cols-1 ${columns === 2 ? "sm:grid-cols-2" : "sm:grid-cols-3"} gap-x-8 gap-y-3`}>
    {items.map((it, i) => (
      <li key={i} className="flex items-start gap-3 text-gray-300 text-sm">
        <span className="mt-1 shrink-0 w-4 h-4 rounded-full border border-[#10B981]/50 flex items-center justify-center">
          <span className="w-1.5 h-1.5 rounded-full bg-[#10B981]" />
        </span>
        {it}
      </li>
    ))}
  </ul>
);
